module.exports = __webpack_public_path__ + "static/media/akash.ec8892ff.jpg";